/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/assassination': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="#1D1D1B"><path pid="0" d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2z"/><path pid="1" d="M21 16.5v-1h6.975A11.978 11.978 0 0016.5 4.025V11h-1V4.025A11.978 11.978 0 004.025 15.5H11v1H4.025A11.978 11.978 0 0015.5 27.975V21h1v6.975A11.978 11.978 0 0027.975 16.5H21zm-5 .5a1 1 0 110-2 1 1 0 110 2z"/></g>'
  }
})
